import React from 'react'
import styled from '@emotion/styled'
import { grayLight30, fontWeightRegular } from '../../constants/principles'

const LargeCheckboxContainer = styled('div')`
  &:disabled,
  &:[disabled] {
    color: ${grayLight30};
  }
`

const LargeCheckboxInput = styled('input')`
  margin: 0 8px 0 0 !important;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  &[disabled],
  &:disabled + label {
    color: ${grayLight30};
  }
`

const LargeCheckboxLabel = styled('label')`
  display: inline;
  font-weight: ${fontWeightRegular};
`

const LargeCheckbox = props => (
  <LargeCheckboxContainer>
    <LargeCheckboxInput data-testid={`${props.testId}-cb`}  id={props.id} type={'checkbox'} disabled={props.disabled} checked={props.isChecked} required={props.required} value={props.value} name={props.name} onChange={props.onChange} />
    <LargeCheckboxLabel data-testid={`${props.testId}-label`} htmlFor={props.id}>{props.children}</LargeCheckboxLabel>
  </LargeCheckboxContainer>
)

LargeCheckbox.displayName = 'LargeCheckbox'

LargeCheckbox.defaultProps = {
  disabled: false
}

export default LargeCheckbox
